export default __webpack_public_path__ + "static/logo-medium-6049497501174815efa42916a4952ccb.svg";